<template>
    <p>This application requires the AlgoSigner browser extension.
        <br>You can <a href="https://chrome.google.com/webstore/detail/algosigner/kmmolakhbgdlpkjkcjkebenjheonagdm">install it here</a> for chromium browsers.
    </p>
</template>
